import { forwardRef } from "react";
import { DisclosurePanel as RACDisclosurePanel } from "react-aria-components";

import { cn } from "../../utils/cn";
import { useAccordionContext } from "./context";

import type { DisclosurePanelProps as RACDisclosurePanelProps } from "react-aria-components";

export interface AccordionContentProps extends Omit<RACDisclosurePanelProps, "className"> {
  className?: string;
}

export const AccordionContent = forwardRef<HTMLDivElement, AccordionContentProps>(
  ({ className, children, ...props }, ref) => {
    const { slots, classNames } = useAccordionContext();
    return (
      <RACDisclosurePanel
        ref={ref}
        {...props}
        className={cn(slots.panel(), classNames?.panel, className)}
      >
        {children}
      </RACDisclosurePanel>
    );
  }
);
AccordionContent.displayName = "AccordionContent";
